import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { AccordionModule } from 'primeng/accordion';
import { MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { PopoverModule } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeModule } from 'primeng/tree';
import { DialogService } from 'primeng/dynamicdialog';
import { SliderModule } from 'primeng/slider';
import { DateMaskDirective } from '../directives/date-mask.directive';
import { TrimValueDirective } from '../directives/trim-value.directive';
import { NoPoBoxAddressDirective } from '../directives/no-pobox-address.directive';
import { CardModule } from 'primeng/card';
import { AvatarModule } from 'primeng/avatar';
import { StepperModule } from 'primeng/stepper';
import { FsToastComponent } from '../components/common-components/fs-toast/fs-toast.component';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TableModule,
    SelectModule,
    TooltipModule,
    TagModule,
    DialogModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    MenuModule,
    AccordionModule,
    CheckboxModule,
    RadioButtonModule,
    PopoverModule,
    TabsModule,
    BadgeModule,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputMaskModule,
    DatePickerModule,
    AutoCompleteModule,
    ChipModule,
    FileUploadModule,
    ProgressBarModule,
    EditorModule,
    ToastModule,
    TimelineModule,
    NgCircleProgressModule,
    SkeletonModule,
    InputNumberModule,
    ToggleSwitchModule,
    ConfirmDialogModule,
    MultiSelectModule,
    TreeModule,
    SliderModule,
    DateMaskDirective,
    TrimValueDirective,
    NoPoBoxAddressDirective,
    CardModule,
    AvatarModule,
    StepperModule,
    FsToastComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TableModule,
    SelectModule,
    TooltipModule,
    TagModule,
    DialogModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    MenuModule,
    AccordionModule,
    CheckboxModule,
    RadioButtonModule,
    PopoverModule,
    TabsModule,
    BadgeModule,
    DividerModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputMaskModule,
    DatePickerModule,
    AutoCompleteModule,
    ChipModule,
    FileUploadModule,
    ProgressBarModule,
    EditorModule,
    ToastModule,
    TimelineModule,
    NgCircleProgressModule,
    SkeletonModule,
    InputNumberModule,
    ToggleSwitchModule,
    ConfirmDialogModule,
    MultiSelectModule,
    TreeModule,
    SliderModule,
    DateMaskDirective,
    TrimValueDirective,
    NoPoBoxAddressDirective,
    CardModule,
    AvatarModule,
    StepperModule,
    FsToastComponent,
  ],
  providers: [MessageService, DialogService]
})
export class SharedModule { }
